//@ts-ingore
import { getConfig } from "@tayar/config";
import { Resend } from "resend";

import { EmailParams } from "./types";

export async function sendResetPasswordEmail({
  to,
  subject,
  resetURL
}: EmailParams) {
  try {
    const config = getConfig();
    if (!config || !config.resendToken) {
      throw new Error("Configuration not found");
    }

    const resend = new Resend(config.resendToken);
    // Send the email
    const { data, error } = await resend.emails.send({
      from: "contact@sikka.io",
      to: to,
      subject: subject,
      text: "From sikka.io",
      html: `<p>You are receiving this because you (or someone else) have requested the reset of the password for your account.</p>
             <p>Please click on the following link, or paste this into your browser to complete the process:</p>
             <p><a href="${resetURL}">Reset Password</a></p>
             <p>If you did not request this, please ignore this email and your password will remain unchanged.</p>`
    });

    if (error) {
      console.error("Error sending email: ❌❌❌ ", error);
    }
    if (data) console.log("Email sent: 😁😁😁", data);
  } catch (error) {
    console.error("Error sending email:❌❌❌", error);
  }
}
